import React, { useEffect, useState } from "react";
import {
    useAppState
} from "./RetailerFitGuide_StateContext";
import Spinner from "/Foundation/Common/code/Views/Foundation/Common/Spinner";
import RetailerFitGuide_ProductListItem from "./Shared/RetailerFitGuide_ProductListItem.jsx";
import ConfirmModal from "/Foundation/Common/code/Views/Foundation/Common/ConfirmModal";
import { TRACK_EVENT_TYPE } from "./Script/RetailerFitGuide_Constants.js";
export const RetailerFitGuide_ProductList = () => {

    const {
        productList,
        setProductList,
        translations,
    } = useAppState();

    const [productsResponse, setProductsResponse] = useState();
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        loadList();
    }, [productList]);

    const loadList = () => {
        const products = productList.map((x) => ({ ProductId: x.ProductId, Quantity: x.Quantity }));

        const payload = {
            productsInput: products,
            additionalData: false 
        };

        fetch("/api/sitecore/fitguide/GetRetailerFitGuideProductListData", {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                setProductsResponse(data);
            })
            .catch(error => console.error("Error:", error));
    }
    const removeListProduct = (productId) => {
        setProductList(prev => prev.filter(x => x.ProductId != productId));
    }

    return <div className="retailerFitGuide_ProductList">
        <h1 className="heading1 mb-0"> {translations.itemList}</h1>

        {!productsResponse && productList?.length > 0 && <div className="mt-4">{translations.loading}... <Spinner /></div>}
        {productsResponse?.ListProducts?.length > 0 ? <div>
            <p className="heading6 my-7">{translations.totalMsrp}: {productsResponse?.TotalPriceFormatted}</p>
            <ul>
                {productsResponse.ListProducts.map((productListItem, index) => <RetailerFitGuide_ProductListItem trackingType={TRACK_EVENT_TYPE.PRODUCTLIST} key={index} productListItem={productListItem} showQuantity={true} removeListProduct={() => removeListProduct(productListItem.ProductId)} />
                )}
            </ul>
            <div className="heading6">{translations.totalMsrp}: {productsResponse?.TotalPriceFormatted}</div>
            <button onClick={() => setShowModal(true)} className="btn thule-btn-secondary w-100 my-9">{translations.clearList}</button>
        </div> : productsResponse && <div className="paragraph">{translations.emptyList}</div>}
        {showModal && <ConfirmModal onCancel={() => setShowModal(false)} onConfirm={() => { setProductList([]); setShowModal(false) }} invertButtonTheme={true} confirmText={translations.yes} cancelText={translations.no} title="Are you sure that you want to clear your list?" />}
    </div>
}